import superagent from 'superagent'

export let getAPi = ((version, api, token, payload, apiUrlPayload) => {
    let baseurl = version == 'v3' ? __API_URI_3__ : version == 'v2' ? '' : __API_URI__
    return new Promise((resolve, reject) => {
        superagent
            .get(`${baseurl}/${apiUrlPayload ? apiUrlPayload : api}`)
            .set('Content-Type', 'application/json')
            .set('Authorization', `Bearer ${token}`)
            .set('Platform', 'Web')
            .set('Version', `${__version__}`)
            .end((err, res) => {
                if (err) {
                    return reject(err.status)
                }
                resolve(res.body)
            })
    })
})